import { Box, Stack, Typography } from '@mui/material';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { LOCALES } from '../../features/language/locales';
import engImg from '../../resources/images/gm_footer_logo_english.png';
import frenchImg from '../../resources/images/gm_footer_logo_french.png';
import { styles } from '../../style/style';
import { LanguageContext } from './LanguageWrapper';


const Footer = () => {
    const context = useContext(LanguageContext);
    let image = "";
    let imageStyle = "";

    if (localStorage.getItem('locale') !== null || localStorage.getItem('locale') === "") {
        if (localStorage.getItem('locale') === LOCALES.ENGLISH_US) {
            image = engImg;
            imageStyle = styles.engImgSx;
        } else if (localStorage.getItem('locale') === LOCALES.FRENCH_CA) {
            image = frenchImg;
            imageStyle = styles.frenchImgSx;
        }
        else {
            image = engImg;
            imageStyle = styles.engImgSx;
        }
    } else {
        if (context.locale === LOCALES.ENGLISH_US) {
            image = engImg;
            imageStyle = styles.engImgSx;
        } else if (context.locale === LOCALES.FRENCH_CA) {
            image = frenchImg;
            imageStyle = styles.frenchImgSx;
        }
        else {
            image = engImg;
            imageStyle = styles.engImgSx;
        }
    }


    return (
        <Box sx={styles.footer}>
            <Stack direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}>
                    
                <Box component="img" sx={imageStyle} alt="Your logo." src={image}/>

                <Typography id='footer.version' sx={styles.footerVersion} >
                    <FormattedMessage id='footer.version' defaultMessage='Version'/>
                    &nbsp;1.0.1
                </Typography>

                <Typography id='footer.copyright' sx={styles.footerCopyright}>
                    <FormattedMessage
                        id='footer.copyright'
                        values={{ year: new Date().getFullYear() }}
                        defaultMessage='© General Motors {year}. All Rights Reserved.' />
                </Typography>
            </Stack>
        </Box>
    )
}

export default Footer